module.exports = __webpack_public_path__ + "img/yuanhuizhen1.c7de6769.png";